'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _quicksend = require('selectors/quicksend');

var _components = require('components');

var _QuickSendRecipients = require('components/QuickSend/QuickSendRecipients');

var _QuickSendRecipients2 = _interopRequireDefault(_QuickSendRecipients);

var _reactRouterRedux = require('react-router-redux');

var _audioplayer = require('redux/modules/audioplayer');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendItem.scss');

var QuickSendItem = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    boxType: ownProps.params.type,
    loadedBoxType: state.quicksend.loadedBoxType,
    qsId: Number(ownProps.params.qsId),
    qsItem: (0, _quicksend.getQuickSendItem)(state, Number(ownProps.params.qsId) || 0),
    qsList: (0, _quicksend.processQuickSends)(state)
  };
}, { playAlbum: _audioplayer.playAlbum, pushState: _reactRouterRedux.push }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendItem, _Component);

  function QuickSendItem() {
    (0, _classCallCheck3.default)(this, QuickSendItem);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendItem.__proto__ || (0, _getPrototypeOf2.default)(QuickSendItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          qsId = _props.qsId,
          pushState = _props.pushState,
          boxType = _props.boxType;

      var isHasId = !!qsId && (0, _isFinite2.default)(qsId);

      if (!isHasId && !this.redirected) {
        if (nextProps.qsList && nextProps.qsList.length && nextProps.boxType === nextProps.loadedBoxType) {
          var redirectId = (0, _get3.default)(nextProps, ['qsList', 0, 'projectId']);
          this.redirected = true;
          pushState('/quick-send/' + boxType + '/' + redirectId);
        }
      } else if (this.redirected && isHasId) {
        this.redirected = false;
      }
    }
  }, {
    key: 'playAll',
    value: function playAll() {
      var album = this.props.qsItem;

      this.props.playAlbum({ album: album, tracks: album.tracks });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          qsId = _props2.qsId,
          qsItem = _props2.qsItem,
          boxType = _props2.boxType,
          loadedBoxType = _props2.loadedBoxType;

      var tracks = qsItem.tracks;
      var isHasTracks = !!(tracks && tracks.length);
      var checkedTracksArr = tracks.map(function (track) {
        return track.track_number;
      });
      var isCanReply = boxType === _projects.quickSendBox.inbox && !!qsItem.recipient_id;

      if (!qsId || boxType !== loadedBoxType) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: styles.item },
        _react2.default.createElement(
          'div',
          { className: styles.subject },
          qsItem.subject,
          isCanReply && _react2.default.createElement(_components.QuickSendReplyButton, { contentKey: qsItem.contentKey, senderName: qsItem.owName })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.fromInfo },
          _react2.default.createElement(
            'div',
            null,
            qsItem.owName
          ),
          qsItem.label_name && _react2.default.createElement(
            'div',
            null,
            t('from {{company}}', { company: qsItem.label_name })
          ),
          _react2.default.createElement(
            'div',
            null,
            qsItem.sentDateTimeText
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.message, hidden: !qsItem.message },
          qsItem.message
        ),
        _react2.default.createElement(_QuickSendRecipients2.default, { recipients: qsItem.recipients }),
        _react2.default.createElement(
          'div',
          { className: styles.playlist },
          isHasTracks && _react2.default.createElement(_components.QuickSendTracklist, { tracks: tracks, album: qsItem, playable: boxType === _projects.quickSendBox.inbox })
        ),
        isHasTracks && boxType === _projects.quickSendBox.inbox && _react2.default.createElement(
          'div',
          { className: 'text-right margin-bottom-20' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary wide margin-top-10', onClick: this.playAll },
            t('Play all')
          ),
          !!qsItem.downloadable && _react2.default.createElement(_components.DownloadTracksButton, {
            className: 'wide margin-top-10 margin-left-10',
            format: 'mp3',
            tracksNumbers: checkedTracksArr,
            contentKey: qsItem.contentKey
          })
        ),
        boxType === _projects.quickSendBox.inbox && _react2.default.createElement(
          'div',
          { className: 'hint small' },
          qsItem.legalNotice
        )
      );
    }
  }]);
  return QuickSendItem;
}(_react.Component), _class3.propTypes = {
  boxType: _propTypes2.default.string,
  loadedBoxType: _propTypes2.default.string,
  playAlbum: _propTypes2.default.func,
  pushState: _propTypes2.default.func,
  qsId: _propTypes2.default.number,
  qsItem: _propTypes2.default.object,
  qsList: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  qsListActionData: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'playAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playAll'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSendItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuickSend/QuickSendItem/QuickSendItem.js
// module id = 2206
// module chunks = 1